module.exports = "/365FarmNet/dist/cfn-import-lifecycle.tpl.a40d89f7e4ca30a095e10efd91b2983b.html";